module.exports = __webpack_public_path__ + "static/frontUserNew/img/fault.afe9cd07.gif";